import { isEmpty } from 'radash';
import { useShallow } from 'zustand/react/shallow';

import { DataModelAttribute } from '@/types/DataModel';

import { useValidationsStore,Validation } from '../hooks/useValidationsStore';
import { useValidationTranslator } from '../hooks/useValidationTranslator';

interface ValidationsBlockProps {
    attribute: DataModelAttribute;
    fieldPath: string;
    gridMode: boolean;
}

const ValidationsBlock = ({ attribute, fieldPath, gridMode }: ValidationsBlockProps) => {

    const validationErrors = useValidationsStore(useShallow(state => state.validationErrors[fieldPath] as Validation[]));
    const localValidationErrors = useValidationsStore(useShallow(state => state.localValidationErrors[fieldPath] as Validation[]));
    const validationWarnings = useValidationsStore(useShallow(state => state.validationWarnings[fieldPath] as Validation[]));

    const hasErrors = !isEmpty(validationErrors);
    const hasLocalErrors = !isEmpty(localValidationErrors);
    const hasWarnings = !isEmpty(validationWarnings);

    const { translateValidationMessage } = useValidationTranslator();

    if (isEmpty(validationErrors) && isEmpty(validationWarnings) && isEmpty(localValidationErrors)) {
        return null;
    }

    if (gridMode) {
        return null;
    }

    return (
        <>
            {
                hasErrors && <div id={attribute.name + '_validations'} className="tw-p-3 tw-bg-error-lighter tw-text-t-sm tw-text-error-dark">
                    <ul className="tw-m-0 tw-pl-5">
                        {validationErrors.map((validation, index) =>
                            <li key={index}>
                                {translateValidationMessage(validation, validation.attributeName)}
                            </li>
                        )}
                    </ul>
                </div>
            }

            {
                hasLocalErrors && <div id={attribute.name + '_validations'} className="tw-p-3 tw-bg-error-lighter tw-text-t-sm tw-text-error-dark">
                    <ul className="tw-m-0 tw-pl-5">
                        {localValidationErrors.map((validation,index) =>
                            <li key={index}>
                                {translateValidationMessage(validation, validation.attributeName)}
                            </li>
                        )}
                    </ul>
                </div>
            }

            {
                hasWarnings && <div id={attribute.name + '_validations'} className="tw-p-3 tw-bg-warning-lighter tw-text-t-sm tw-text-warning-dark">
                    <ul className="tw-m-0 tw-pl-5">
                        {validationWarnings.map((validation,index) =>
                            <li key={index}>
                                {translateValidationMessage(validation, validation.attributeName)}
                            </li>
                        )}
                    </ul>
                </div>
            }
        </>
    );
};

export { ValidationsBlock };
